import { useDatabaseInstancesQuery } from 'hooks/queries/dbo';
import { mapDboV2Instances } from '../utils/instanceToViewV2';
import { useCurrentOrganizationId } from '@cast/infrastructure-organization';

export const useInstances = () => {
  const organizationId = useCurrentOrganizationId();

  return useDatabaseInstancesQuery(
    { organizationId: organizationId ?? '' },
    { enabled: !!organizationId, select: mapDboV2Instances }
  );
};
